<template>
  <a-modal v-model="visible" :title="form.tripproject_id ? '编辑项目' : '创建项目'" @ok="handleOk" @cancel="handleClose"
    :confirmLoading="confirmLoading" :maskClosable="false" width="1266px" destroyOnClose>
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-model-item label="项目名称" prop="project_name">
            <a-input v-model="form.project_name" placeholder="请输入项目名称"></a-input>
          </a-form-model-item>
          <a-form-model-item label="供应商项目" prop="goods_id">
            <!-- :disabled="!!form.tripproject_id" -->
            <el-cascader filterable style="width: 100%" v-model="form.goods_id" :options="supplierList"
              :show-all-levels="true" @change="supplierChange"></el-cascader>
          </a-form-model-item>
          <!-- <template v-if="!!form.project_name"> -->
          <a-form-model-item label="成本单价" prop="project_cost">
            <a-input-number v-model="form.project_cost" :min="0" :step="0.01" :precision="2" style="width: 100%"
              placeholder="请输入项目成本单价" />
          </a-form-model-item>
          <a-form-model-item label="售卖单价" prop="project_price">
            <a-input-number v-model="form.project_price" :min="0" :step="0.01" :precision="2" style="width: 100%"
              placeholder="请输入项目售卖单价" />
          </a-form-model-item>
          <a-form-model-item label="数量" prop="project_num">
            <a-input-number v-model="form.project_num" :min="0" :step="1" :precision="1" style="width: 100%"
              placeholder="项目数量" />
          </a-form-model-item>
          <a-form-model-item label="计价单位">
            <a-row>
              <a-col :span="8">
                <a-form-model-item prop="days_unit">
                  <a-switch :checked="form.days_project == 1" @change="(e) => (form.days_project = e ? 1 : 2)" />
                </a-form-model-item>
              </a-col>
              <a-col :span="16">
                <a-form-model-item label="计价数量" prop="days" :label-col="{ span: 10 }" v-if="form.days_project == 1">
                  <a-input-number @change="(e) => form.days = e == null ? form.days = 1 : e" v-model="form.days"
                    :min="1" :step="1" :precision="0" placeholder="计价数量" />
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-alert message="如开启【计价单位】后，计价数量将参与计算：价格*数量*计价数量" banner />
          </a-form-model-item>
          <a-form-model-item label="计价含义" prop="days_unit">
            <a-input v-model="form.days_unit" :placeholder="days_unit_message">
              <a-tooltip slot="suffix" :title="days_unit_message">
                <a-icon type="question-circle" style="color: rgba(0, 0, 0, 0.45)" />
              </a-tooltip>
            </a-input>
          </a-form-model-item>
          <a-form-model-item required label="小计">
            {{ price_total }}
          </a-form-model-item>
          <!-- </template> -->
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="项目当天日期" prop="play_time">
            <!-- <a-date-picker style="width: 100%;" :format="'YYYY/MM/DD'" :valueFormat="'YYYY/MM/DD 00:00:00'"
              v-model="form.play_time" /> -->
            <el-date-picker type="dates" style="width: 100%;" v-model="form.play_time" placeholder="选择一个或多个日期"
              @change="() => $refs.ruleForm.validateField('play_time')" value-format="yyyy-MM-dd"
              :format="'yyyy-MM-dd'">
            </el-date-picker>
          </a-form-model-item>
          <a-form-model-item label="收到定金" prop="deposit">
            <a-input-group compact>
              <a-input-number style="width: 70%;" prefix="￥" v-model="form.deposit" :step="0.01" :precision="2"
                placeholder="请输入已经收到的定金金额" @blur="Blur1" />
              <div style="width: 25%; text-align: center;">
                <a-switch v-model="changeBand1" size="small"></a-switch>
                <div style="font-size: 11px;">自动补算尾款</div>
              </div>
            </a-input-group>
          </a-form-model-item>
          <a-form-model-item label="收到尾款" prop="arrears">
            <a-input-group compact>
              <a-input-number style="width: 70%;" v-model="form.arrears" :step="0.01" :precision="2"
                placeholder="请输入已经收到的项目尾款金额" @blur="Blur2" />
              <div style="width: 25%; text-align: center;">
                <a-switch v-model="changeBand2" size="small"></a-switch>
                <div style="font-size: 11px;">自动补算定金</div>
              </div>
            </a-input-group>

          </a-form-model-item>
          <a-form-model-item label="定金&尾款备注">

            <a-textarea v-model="form.money_remark" placeholder="定金和尾款的备注（如什么时间收款或其他事项）" :rows="4" />
          </a-form-model-item>
          <a-form-model-item label="项目旁白">
            <a-textarea v-model="form.project_remark" placeholder="项目旁白（入住时间或使用期限等信息）" :rows="4" />
          </a-form-model-item>
          <a-form-model-item label="项目备注">
            <a-textarea v-model="form.project_remark2" placeholder="项目备注（中途更换车型等细节问题）" :rows="4" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="导出是否显示">
            <a-radio-group v-model="form.is_show">
              <a-radio value="1">
                显示
              </a-radio>
              <a-radio value="2">
                不显示
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否已发预订单">
            <a-radio-group v-model="form.is_yuding">
              <a-radio value="1">
                是（已发）
              </a-radio>
              <a-radio value="2">
                否（未发）
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item label="是否给供应商结算">
            <a-radio-group v-model="form.is_jiesuan">
              <a-radio value="1">
                是（已结算）
              </a-radio>
              <a-radio value="2">
                否（未结算）
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
          <a-form-model-item>
            <a-spin :indicator="() => null" :spinning="!form.tripproject_id" tip="新增后可编辑资料">
              <a-upload-dragger name="file" :multiple="false" :action="baseURL + '/admin/sys/upload'"
                @change="handleChange">
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" />
                </p>
                <p class="ant-upload-text">
                  单击或拖动文件到此区域进行上传
                </p>
                <p class="ant-upload-hint">
                  用于留存收款图片或发票文件等
                </p>
              </a-upload-dragger>
              <a-list :locale="{ emptyText: '暂未上传图片或发票文件' }" class="demo-loadmore-list" item-layout="horizontal"
                :data-source="fileList">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a slot="actions" @click="prewview(item.url)" v-if="checkFileType(item.url) == 1">预览</a>
                  <a slot="actions" @click="download(item.url)">下载</a>
                  <a slot="actions" @click="del(item.id)" :disabled="readonly">删除</a>
                  <a-list-item-meta :description="item.create_time">
                    <a slot="title">{{ checkFileType(item.url) == 1 ? '图片类型' : '文件类型' }}({{
                      item.url.substr(0, 12) + '...' +
                      item.url.substr(item.url.length
                        - 12, item.url.length - 1) }})</a>
                    <a-avatar slot="avatar"
                      :style="{ backgroundColor: checkFileType(item.url) == 1 ? '#87d068' : '#1890FF' }"
                      :icon="checkFileType(item.url) == 1 ? 'file-image' : 'file'" />
                  </a-list-item-meta>
                </a-list-item>
                <!-- checkFileType -->
              </a-list>
            </a-spin>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
import Decimal from "decimal.js";
import { baseURL } from "@/api/index";
export default {
  data() {
    return {
      baseURL,
      visible: false,
      confirmLoading: false,
      changeBand1: true,//定金失去焦点计算
      changeBand2: true,//尾款失去焦点计算
      days_unit_message:
        "计价含义, 如公里/位/天/小时/小份/分钟或其他信息（可不填）",
      fileList: [],
      form: {
        trip_id: "", //行程项目ID
        tripproject_id: "",
        goods_id: [],
        project_name: "",
        project_cost: "", //成本
        project_price: "", //售价
        project_num: 1, //数量
        project_remark: "", //项目旁白
        project_remark2: "",//备注
        sort: 0,
        days: 1,
        days_unit: "", //天数单位
        days_project: 1, //天数是否参与计算1是2否
        deposit: 0,//定金
        arrears: 0,//尾款
        money_remark: '',
        play_time: [],
        is_show: "1",
        is_yuding: '2',
        is_jiesuan: '2'
      },
      submitLoading: false,
      rules: {
        project_name: [
          {
            required: true,
            message: "项目必填",
            trigger: "change",
          },
        ],
        goods_id: [
          {
            required: true,
            message: "请选择供应商项目",
            trigger: "change",
          },
        ],
        project_cost: [
          {
            required: true,
            message: "请输入项目成本价",
            trigger: "change",
          },
        ],
        project_price: [
          {
            required: true,
            message: "请输入项目价格",
            trigger: "change",
          },
        ],
        project_num: [
          {
            required: true,
            message: "请输入项目数量",
            trigger: "change",
          },
        ],
        play_time: {
          required: true,
          message: "请选择项目当天使用日期",
          trigger: "change",
        },
        deposit: {
          required: true,
          message: "不能是空的，0都行",
          trigger: "change",
        },
        arrears: {
          required: true,
          message: "不能是空的，0都行",
          trigger: "change",
        }
      },
      supplierList: [],
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      form2: {},
    };
  },
  created() {
    this.form2 = JSON.parse(JSON.stringify(this.form));
    this.getSupplierList();
  },
  computed: {
    price_method() {
      const days = new Decimal(
        this.form.days_project == 1 ? (this.form.days || 1) : 1
      );
      const project_price = new Decimal(this.form.project_price || 0);
      const project_num = new Decimal(this.form.project_num || 0);
      // 进行乘法运算
      let result = days.times(project_price).times(project_num);
      return result
    },
    price_total() {
      const result = this.price_method;
      return `${result.toString()}元 (${this.form.project_price} * ${this.form.project_num
        } ${this.form.days_project == 1
          ? " * " + this.form.days + this.form.days_unit
          : ""
        })`;
    },
  },
  methods: {
    init(trip_id, tripproject_id) {
      this.form.trip_id = trip_id;
      this.form.tripproject_id = tripproject_id;
      this.visible = true;
      if (tripproject_id) {
        this.getInfo();
        this.getFiles()
      }
    },
    getInfo() {
      this.$http({
        url: "/admin/tripproject/info",
        method: "post",
        data: {
          id: this.form.tripproject_id,
        },
      }).then((res) => {
        this.form = {
          ...res.data,
        };
      });
    },
    supplierChange(value) {
      const labels = this.getLabelsFromValue(value, this.supplierList);
      if (this.form.project_name == '') {
        this.form.project_name = labels[0] + "-" + labels[1] + "-" + labels[2];
      }
    },
    prewview(url) {
      this.$viewerApi({
        images: [url],
      });
    },
    download(url) {
      window.open(url)
    },
    checkFileType(url) {
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];

      // 判断 URL 是否以图片扩展名结尾
      if (imageExtensions.some(ext => url.toLowerCase().endsWith(ext))) {
        return 1; // 图片
      }

      return 2; // 文件
    },
    del(id) {
      this.$confirm({
        title: '是否确认删除当前文件资料?',
        content: '删除后将不可恢复',
        okText: '确认删除',
        okType: 'danger',
        onOk: () => {
          this.$http({
            url: '/admin/tripproject/fileDelete',
            method: 'post',
            data: { id }
          }).then(() => {
            this.$message.success("删除成功, 收款资料已更新")
            this.getFiles()
          })
        },

      });
    },
    handleChange(info) {
      const status = info.file.status;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        // this.$message.success(`${info.file.name} 上传成功`);
        const url = info.file.response.data.url
        this.$http({
          url: '/admin/tripproject/addFiles',
          method: 'post',
          data: {
            tripproject_id: this.form.tripproject_id,
            url: url
          }
        }).then(() => {
          this.$message.success("上传成功,资料已更新")
          this.getFiles()
        })
      } else if (status === 'error') {
        this.$message.error(`${info.file.name} 文件上传失败`);
      }
    },
    getSupplierList() {
      this.$http({
        url: "/admin/supplier/goodsChildren",
        method: "get",
      }).then((res) => {
        this.supplierList = res.data;
      });
    },
    //获取所有资料
    getFiles() {
      this.$http({
        url: '/admin/tripproject/getFiles',
        data: {
          tripproject_id: this.form.tripproject_id
        },
        method: 'post'
      }).then(res => {
        this.fileList = res.data
      })
    },
    // 递归查找对应的label
    getLabelsFromValue(value, options) {
      let labels = [];
      for (let item of options) {
        if (item.value === value[0]) {
          // 如果找到匹配的value
          labels.push(item.label);
          if (item.children) {
            labels = labels.concat(
              this.getLabelsFromValue(value.slice(1), item.children)
            ); // 递归查找子级
          } else {
            this.goodsinfo(item);
          }
          break;
        }
        if (item.children) {
          labels = labels.concat(this.getLabelsFromValue(value, item.children)); // 递归查找子级
        }
      }
      return labels;
    },
    //商品项目级选择回调
    goodsinfo(e) {
      console.log(e);
      this.form.project_cost = e.goods_cost;
      this.form.project_price = e.goods_price;
      this.form.days_unit = e.unit;
      this.form.project_remark = e.remark;
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log(this.form.play_time, this.form.days)
          if (this.form.days_project == 1 && this.form.days > 1 && (this.form.play_time.length != this.form.days)) {
            this.$confirm({
              title: `计价数量为${this.form.days}, 但是日期选择了${this.form.play_time.length}天`,
              content: '是否继续提交',
              onOk: () => {
                this.postmethod();
              },
            });
          } else {
            this.postmethod();
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    postmethod() {
      this.confirmLoading = true;
      this.$http({
        url: this.form.tripproject_id
          ? "/admin/tripproject/update"
          : "/admin/tripproject/create",
        method: "post",
        data: this.form,
      })
        .then(() => {
          this.$message.success(
            this.form.tripproject_id ? "修改项目成功" : "创建项目成功"
          );
          this.handleClose();
          this.$emit("ok");
        })
        .finally(() => (this.confirmLoading = false));
    },
    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.form = JSON.parse(JSON.stringify(this.form2));
      this.visible = false;
    },
    //定金
    Blur1(e) {
      if (this.changeBand1) {
        //小记
        const result = this.price_method;
        //定金
        const value = new Decimal(e.target.value || 0);
        //小记 - 定金
        const result2 = result.minus(value).toNumber();
        debugger
        this.form.arrears = result2
      }
    },
    //尾款
    Blur2(e) {
      if (this.changeBand2) {
        //小记
        const result = this.price_method;
        //尾款
        const value = new Decimal(e.target.value || 0);
        //小记 - 尾款
        const result2 = result.minus(value).toNumber();
        this.form.deposit = result2
      }
    },
  },
};
</script>

<style></style>